import { useMutation, useQueryClient } from "@tanstack/react-query";
import { httpRequest } from "@/lib/axios";
import { RequestSchedulingResponse, UpdateScheduleRequestDTO } from "@/types";

async function updateSchedule(
  request: UpdateScheduleRequestDTO
): Promise<RequestSchedulingResponse> {
  const { id, ...updateData } = request;

  const response = await httpRequest.put<RequestSchedulingResponse>(
    `/schedulings/${id}`,
    updateData
  );
  return response.data;
}

export function useUpdateSchedulingMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updateSchedule,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["schedulings"] });
    },
  });
}
